import React, { Suspense, useState } from 'react';
import Title from '@/components/title';
import { Button, Checkbox, GetProp } from 'antd';
import { CloseOutlined, PrinterOutlined } from '@ant-design/icons';
import { printTemplates } from '@/configs/templates';
import Card from '@/components/card';
import { IDataModal } from '@/interfaces/dataModal';
import { IOrder } from '@/interfaces/order';
import { isWareHouse } from '@/utils/permissionUtils';
import PrintMultiModal from '@/components/templates/print-multi-modal';
const _modal: IDataModal<IOrder[]> = {
  open: false,
};
interface IProps {
  data: IOrder[];
  afterPrint: () => void;
  onCancel: () => void;
}
const OrderMultiPrint = ({ data, afterPrint, onCancel }: IProps) => {
  const isWarehouseRole = isWareHouse();
  const [print, setPrint] = useState<IDataModal<IOrder[]>>({ ..._modal });
  const [templates, setTemplates] = useState<string[]>([]);

  const onChange: GetProp<
    typeof Checkbox.Group,
    'onChange'
  > = checkedValues => {
    if (checkedValues.includes('TM16') && !checkedValues.includes('TM12')) {
      checkedValues = [...checkedValues, 'TM12'];
    }
    console.log('checkedValues', checkedValues);
    setTemplates(checkedValues as string[]);
  };
  const ordersCode = data.map(e => e.code).join(',');
  return (
    <Card>
      <Title title="รายการออเดอร์" subtitle={`${ordersCode}`}>
        <div className="flex justify-end items-end">
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => onCancel()}
          />
        </div>
      </Title>

      <Checkbox.Group
        style={{ width: '100%' }}
        onChange={onChange}
        defaultValue={templates}
        disabled={!!isWarehouseRole}
      >
        <div className="grid md:grid-cols-4 w-full gap-4 h-full">
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบส่งของ"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM01', 'TM02', 'TM03'].includes(t.key))
              .map(p => (
                <Checkbox className="flex" key={p.key} value={p.key}>
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบแจ้งหนี้"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM04', 'TM05', 'TM05-2'].includes(t.key))
              .map(p => (
                <Checkbox className="flex" key={p.key} value={p.key}>
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบกำกับภาษี"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM06', 'TM07', 'TM07-2'].includes(t.key))
              .map(p => (
                <Checkbox className="flex" key={p.key} value={p.key}>
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบกำกับสินค้า"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM08', 'TM09'].includes(t.key))
              .map(p => (
                <Checkbox className="flex" key={p.key} value={p.key}>
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบเสร็จรับเงิน"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM10', 'TM11', 'TM11-2'].includes(t.key))
              .map(p => (
                <Checkbox className="flex" key={p.key} value={p.key}>
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="ใบส่งสินค้า"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t =>
                ['TM12', 'TM13', 'TM14', 'TM15', 'TM16'].includes(t.key),
              )
              .map(p => (
                <Checkbox
                  className="flex"
                  key={p.key}
                  value={p.key}
                  disabled={['TM16'].includes(p.key)}
                >
                  {p.name}
                </Checkbox>
              ))}
          </Card>
          <Card
            customClass="drop-shadow-none w-full p-3 flex flex-col h-full"
            customContainerClass="p-0 flex-grow"
          >
            <Title
              title="อื่นๆ"
              customContainerClassName="p-0"
              customClassName="text-base mb-2"
            />
            {printTemplates
              ?.filter(t => ['TM17', 'TM18', 'TM19'].includes(t.key))
              .map(p => (
                <Checkbox
                  className="flex"
                  key={p.key}
                  value={p.key}
                  disabled={['TM17', 'TM18'].includes(p.key)}
                >
                  {p.name}
                </Checkbox>
              ))}
          </Card>
        </div>
      </Checkbox.Group>
      <Suspense>
        <PrintMultiModal
          open={print.open}
          handleCancel={function (): void {
            setPrint({
              ..._modal,
            });
          }}
          afterPrint={() => {
            setPrint({
              ..._modal,
            });
            afterPrint();
          }}
          order={data}
          tms={templates}
        />
      </Suspense>
      <div className="flex justify-center mt-6">
        <Button
          type="primary"
          disabled={!templates.length}
          onClick={() => {
            setPrint({
              item: data,
              open: true,
              id: 'TM_ALL',
            });
          }}
        >
          <PrinterOutlined />
          {`พิมพ์เอกสารทั้งหมด  ${templates.length * data.length} รายการ`}
        </Button>
      </div>
    </Card>
  );
};

export default OrderMultiPrint;
